import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid/lib/index";
import { List } from "immutable";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Button
} from "@material-ui/core";

import FilterCard from "./FilterCard";
import TableCard from "./TableCard";
import MapCard from "./MapCard";
import MapSearch from "./MapSearch";
import ChartCard from "./ChartCard";

const CustomTabPanel = props => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

CustomTabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

const DownloadLayout = props => {
  const [markerPoints, setMarkerPoints] = useState([]);
  const [spatialSearchEnabled, setSpatialSearchEnabled] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [showMap, setShowMap] = useState(false);
  const [openMapSearchModal, setOpenMapSearchModal] = useState(false);
  const [siteIDOptions, setSiteIDOptions] = useState([]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleOpenMapSearch = options => {
    setSiteIDOptions(options);
    setOpenMapSearchModal(true);
  };

  const handleCloseMapSearch = () => {
    setOpenMapSearchModal(false);
  };

  const processAndSetMarkerPoints = (data, siteData) => {
    const locations = data
      .map(item => {
        const obj = item.toJS();

        if (obj.lat == null && obj.long == null) {
          if (obj.site_lat != null && obj.site_long != null) {
            obj.lat = obj.site_lat;
            obj.long = obj.site_long;
          } else if (obj.site_id != null && siteData[obj.site_id]) {
            obj.lat = siteData[obj.site_id].latitude;
            obj.long = siteData[obj.site_id].longitude;
          }
        }

        return obj;
      })
      .filter(item => item.lat != null && item.long != null);
    setMarkerPoints(locations);
  };

  useEffect(() => {
    if (props.filteredDownloadData && props.filteredDownloadData.size > 0) {
      const data = props.filteredDownloadData.toArray();

      processAndSetMarkerPoints(data, props.siteData);
    }
  }, [props.filteredDownloadData]);

  return (
    <div>
      <Row>
        <Col xs={12}>
          <FilterCard
            {...props}
            markerPoints={markerPoints}
            setMarkerPoints={setMarkerPoints}
            setSpatialSearchEnabled={setSpatialSearchEnabled}
            setShowMap={setShowMap}
            setTabValue={setTabValue}
            handleOpenMapSearch={handleOpenMapSearch}
          />
        </Col>
      </Row>
      <Box sx={{ width: "100%" }}>
        <CustomTabPanel value={tabValue} index={0}>
          <TableCard
            {...props}
            handleTabChange={handleTabChange}
            tabValue={tabValue}
          />
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={1}>
          <MapCard
            {...props}
            markerPoints={markerPoints}
            showMap={showMap}
            setShowMap={setShowMap}
            handleTabChange={handleTabChange}
            tabValue={tabValue}
          />
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={2}>
          <ChartCard
            {...props}
            showMap={showMap}
            handleTabChange={handleTabChange}
            tabValue={tabValue}
          />
        </CustomTabPanel>
      </Box>
      <Dialog
        open={openMapSearchModal}
        onClose={handleCloseMapSearch}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Spatial Search</DialogTitle>
        <DialogContent>
          <MapSearch
            siteData={props.siteData}
            changeChip={props.changeChip}
            spatialSearchEnabled={spatialSearchEnabled}
            fetchData={props.actions.fetchData}
            siteIDOptions={siteIDOptions}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              margin: "20px"
            }}
          >
            <Button variant="contained" onClick={handleCloseMapSearch}>
              OK
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

DownloadLayout.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  filteredDownloadData: PropTypes.instanceOf(List).isRequired,
  filterChanged: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  siteData: PropTypes.object.isRequired,
  changeChip: PropTypes.func.isRequired,
  actions: PropTypes.shape({
    fetchData: PropTypes.func.isRequired
  }).isRequired
};

export default DownloadLayout;
